export default {
  // Common / Navigation
  siteName: "CSSBuy Spreadsheet",
  siteSubtitle: "Resource Center",
  nav: {
    home: "Home",
    categories: "Categories",
    products: "Products",
    guides: "Guides",
    reviews: "Reviews",
    shipping: "Shipping",
    qc: "QC",
    sellers: "Sellers",
    safety: "Safety",
    shoppingGuide: "Shopping Guide",
    language: "Language",
  },
  cta: {
    explore: "Explore CSSBuy Spreadsheet",
    guides: "Read CSSBuy Guides",
    buyNow: "Buy It Now",
    visitMain: "Visit Main Website",
    readMore: "Read More",
    search: "Search",
  },
  footer: {
    disclaimer: "cssbuybr.quest is an independent informational resource and is not affiliated with or endorsed by CSSBuy unless explicitly stated.",
    links: {
      spreadsheet: "CSSBuy Spreadsheet",
      products: "Products",
      sellers: "Sellers",
      guides: "Guides",
      reviews: "Reviews",
      shipping: "Shipping",
      qc: "QC",
      comparisons: "Comparisons",
      safety: "Safety",
      about: "About",
      contact: "Contact",
      editorial: "Editorial Policy",
      privacy: "Privacy Policy",
      terms: "Terms",
    },
    languages: "Languages",
  },
  // Home Page
  home: {
    hero: {
      h1: "CSSBuy Spreadsheet — Find Products, Sellers & Buying Guides",
      subtitle: "Explore CSSBuy Spreadsheet resources, products, sellers, QC information, shipping guides and practical buying resources in one organized hub.",
      cta1: "Explore CSSBuy Spreadsheet",
      cta2: "Buy It Now",
      trust: "Updated guides • Organized resources • Practical tips",
    },
    categories: {
      title: "Find what you need quickly",
      subtitle: "Browse categories in the CSSBuy Spreadsheet",
    },
    whatIs: {
      title: "What is CSSBuy Spreadsheet?",
      content: "CSSBuy Spreadsheet is a practical way to organize and discover products, sellers, and resources related to CSSBuy. Our hub brings together lists, categories, QC information, shipping details, and guides in one place to make your research easier. Whether you are looking for sneakers, hoodies, accessories, or perfume, the CSSBuy Spreadsheet helps you navigate the world of international buying with clarity and confidence.",
      cta: "Explore the CSSBuy Spreadsheet List",
    },
    guides: {
      title: "Popular CSSBuy Guides",
      items: [
        { title: "CSSBuy Review", desc: "Honest review of CSSBuy platform features and experience" },
        { title: "CSSBuy Shipping Cost", desc: "Complete shipping cost guide and methods comparison" },
        { title: "Is CSSBuy Legit?", desc: "Safety analysis and trust verification guide" },
        { title: "CSSBuy Warehouse", desc: "How warehouse storage and processing works" },
        { title: "CSSBuy Coupon", desc: "How to find and use CSSBuy discount codes" },
        { title: "CSSBuy QC Guide", desc: "Quality check photo guide and inspection tips" },
      ],
    },
    whyUs: {
      title: "Why use our CSSBuy Spreadsheet?",
      content: "Our goal is to organize useful information in a simple, searchable format. Content is structured by search intent, category, and topic to help you find the right resource quickly.",
      features: [
        { title: "Organized", desc: "All resources sorted by category and intent" },
        { title: "Practical", desc: "Actionable tips and step-by-step guides" },
        { title: "Updated", desc: "Regularly refreshed content and links" },
        { title: "Transparent", desc: "No fake reviews or misleading claims" },
      ],
    },
    articles: {
      title: "Latest CSSBuy Articles",
      subtitle: "Read in-depth SEO guides and resources",
    },
    faq: {
      title: "Frequently Asked Questions",
      items: [
        { q: "What is CSSBuy Spreadsheet?", a: "CSSBuy Spreadsheet is an organized resource hub that helps buyers find products, sellers, shipping guides, and QC information related to CSSBuy in one place." },
        { q: "Is CSSBuy legit and safe?", a: "CSSBuy is a known proxy buying service. Our guides help you verify safety, check QC photos, and follow best practices for secure transactions." },
        { q: "How do I find products on CSSBuy?", a: "Use the category filters or search feature in the CSSBuy Spreadsheet to browse products by type, seller, or price range." },
        { q: "Does CSSBuy offer coupons?", a: "Yes, CSSBuy occasionally offers coupon codes and discounts. Our guide shows you where to find the latest CSSBuy coupons." },
      ],
    },
    safety: {
      title: "CSSBuy Safety Center",
      content: "Learn how to identify suspicious links, protect your information, verify pages before entering payment details, understand shipping risks, and avoid potential scams or fake websites. Always verify the website URL before entering payment or account information.",
      cta: "Visit Safety Center",
    },
    finalCta: {
      title: "Ready to explore CSSBuy Spreadsheet?",
      content: "Find products, sellers, and CSSBuy resources in one place.",
      cta: "Explore CSSBuy Spreadsheet",
      secondary: "Visit our main website",
    },
    products: {
      title: "Browse Products",
      subtitle: "Discover curated products from our main catalog",
      viewAll: "View All Products",
    },
  },
  // Article Page
  article: {
    meta: {
      author: "CSSBuy Spreadsheet Team",
      published: "Published",
      updated: "Updated",
      readingTime: "min read",
    },
    related: "Related Articles",
    toc: "Table of Contents",
    cta: "Explore CSSBuy Spreadsheet",
    comparisonTable: "Comparison Table",
    faqTitle: "FAQ",
    readyToExplore: "Ready to explore CSSBuy Spreadsheet?",
    findResources: "Find products, sellers, and resources in one place.",
  },
  // Categories
  categories: [
    { name: "Shoes", slug: "shoes", url: "https://kaspreadsheet.com/category-911-Shoes.html" },
    { name: "Hoodies/Sweaters", slug: "hoodies", url: "https://kaspreadsheet.com/category-912-Hoodies%2FSweaters.html" },
    { name: "T-Shirts", slug: "t-shirts", url: "https://kaspreadsheet.com/category-913-T-Shirts.html" },
    { name: "Jackets", slug: "jackets", url: "https://kaspreadsheet.com/category-914-Jackets.html" },
    { name: "Pants/Shorts", slug: "pants", url: "https://kaspreadsheet.com/category-915-Pants%2FShorts.html" },
    { name: "Headwear", slug: "headwear", url: "https://kaspreadsheet.com/category-916-Headwear.html" },
    { name: "Sets", slug: "sets", url: "https://kaspreadsheet.com/category-917-Sets.html" },
    { name: "Underwear/Underpants", slug: "underwear", url: "https://kaspreadsheet.com/category-918-underwear%2Funderpants.html" },
    { name: "Jersey", slug: "jersey", url: "https://kaspreadsheet.com/category-919-Jersey.html" },
    { name: "Accessories", slug: "accessories", url: "https://kaspreadsheet.com/category-920-Accessories.html" },
    { name: "Bags", slug: "bags", url: "https://kaspreadsheet.com/category-921-Bags.html" },
    { name: "Belts", slug: "belts", url: "https://kaspreadsheet.com/category-922-Belts.html" },
    { name: "Perfumes", slug: "perfumes", url: "https://kaspreadsheet.com/category-923-Perfumes.html" },
    { name: "Other Stuff", slug: "other", url: "https://kaspreadsheet.com/category-924-Other+Stuff.html" },
  ],
  // Articles list
  articlesList: [
    {
      slug: "cssbuy-spreadsheet-2026-complete-guide",
      title: "CSSBuy Spreadsheet 2026: Complete Product & Seller Guide",
      desc: "The most comprehensive guide to using CSSBuy Spreadsheet for finding products, sellers, and shipping resources in 2026.",
      date: "2026-08-27",
    },
    {
      slug: "cssbuy-review-2026",
      title: "CSSBuy Review 2026: Is CSSBuy Legit & Safe?",
      desc: "An honest review of CSSBuy features, fees, security, and overall experience for international buyers in 2026.",
      date: "2026-08-27",
    },
    {
      slug: "cssbuy-shipping-cost-2026",
      title: "CSSBuy Shipping Cost 2026: Complete Shipping Guide",
      desc: "A detailed breakdown of CSSBuy shipping costs, methods, and tips to reduce international shipping fees.",
      date: "2026-08-27",
    },
    {
      slug: "cssbuy-warehouse-guide",
      title: "CSSBuy Warehouse Guide: Storage, QC & Shipping",
      desc: "How the CSSBuy warehouse works, including storage, quality checks, consolidation, and shipping processing.",
      date: "2026-08-27",
    },
    {
      slug: "cssbuy-qc-guide",
      title: "CSSBuy QC Guide: How to Read Quality Check Photos",
      desc: "Learn how to read CSSBuy quality check photos to verify products before international shipping.",
      date: "2026-08-27",
    },
    {
      slug: "cssbuy-coupon-guide",
      title: "CSSBuy Coupon Guide 2026: How Discounts Work",
      desc: "How to find and use CSSBuy coupons, discount codes, and promotions to save on fees and shipping.",
      date: "2026-08-27",
    },
    {
      slug: "cssbuy-buying-guide",
      title: "CSSBuy Buying Guide: Complete Beginner Tutorial",
      desc: "A step-by-step beginner tutorial covering everything from placing your first order to receiving your package.",
      date: "2026-08-27",
    },
    {
      slug: "cssbuy-seller-guide",
      title: "CSSBuy Seller Guide: How to Find Reliable Sellers",
      desc: "Practical tips to identify reliable sellers, evaluate store reputation, and avoid common purchasing mistakes.",
      date: "2026-08-27",
    },
    {
      slug: "cssbuy-vs-superbuy",
      title: "CSSBuy vs Superbuy: Which Proxy Service Is Better?",
      desc: "A side-by-side comparison of CSSBuy and Superbuy covering fees, shipping, warehouse, and customer support.",
      date: "2026-08-27",
    },
    {
      slug: "cssbuy-product-search-guide",
      title: "CSSBuy Product Search Guide: How to Find Items",
      desc: "How to search for products effectively using the CSSBuy Spreadsheet and category filters.",
      date: "2026-08-27",
    },
    {
      slug: "cssbuy-alternatives",
      title: "CSSBuy Alternatives: Best Proxy Services Compared",
      desc: "A comparison of the best CSSBuy alternatives for international proxy buying in 2026.",
      date: "2026-08-27",
    },
  ],
  // 404
  notFound: {
    title: "Page Not Found",
    desc: "The page you are looking for does not exist or has been moved.",
    back: "Back to Home",
  },
  // Products Page
  products: {
    title: "All Products",
    subtitle: "Browse the full catalog of products available through CSSBuy Spreadsheet.",
    filterBy: "Filter by Category",
    allCategories: "All Categories",
    buyNow: "Buy Now",
    showing: "Showing",
    products: "products",
    noProducts: "No products found in this category.",
  },
};